import { useSelector } from 'react-redux';
import { selectTheme } from 'redux/selectors/config';

export const useNotFound = () => {
  const themeData = useSelector(selectTheme);
  return { themeData };
};
